export default "__VITE_ASSET__DiufgF4a__"